import { createHttpService } from 'src/apis/ApiService';
import { TPaginationParams } from 'src/apis/__shared/shared.interfaces';
import {
  IGuardianApplyLeavePayload,
  IGuardianLeaveRecord,
  IGuardianLeaveStatsResponse,
} from '../guardianLeaves.interfaces';
import {
  mockGuardianLeaveStats,
  mockGuardianLeaveList,
} from 'src/__mocks__/guardian/guardianLeavesMock';
import isAppWithMock from 'src/utils/isAppWithMock';

const baseGuardianLeavesPath = '/guardian/leaves';

const useGuardianLeavesService = () => {
  const httpAPI = createHttpService();
  const withMockData = isAppWithMock();

  const getLeaveStats = (): Promise<IGuardianLeaveStatsResponse> => {
    if (withMockData) return Promise.resolve(mockGuardianLeaveStats);
    return httpAPI
      .get<IGuardianLeaveStatsResponse>(`${baseGuardianLeavesPath}/stats`)
      .then((res: any) => res?.data ?? res ?? { stats: [] });
  };

  const getLeaves = (_params: TPaginationParams): Promise<IGuardianLeaveRecord[]> => {
    if (withMockData) return Promise.resolve(mockGuardianLeaveList);
    return httpAPI
      .get<any>(baseGuardianLeavesPath, {
        params: { page: _params.page, limit: _params.limit },
      })
      .then((res: any) => {
        const body = res?.data ?? res;
        return Array.isArray(body?.data) ? body.data : body ?? [];
      });
  };

  const applyLeave = (payload: IGuardianApplyLeavePayload): Promise<IGuardianLeaveRecord> => {
    if (withMockData) {
      return Promise.resolve({
        id: 'gleave-new',
        leaveTypeId: payload.leaveTypeId,
        leaveTypeName: 'Leave',
        leaveTypeCode: 'paid',
        startDate: payload.startDate,
        endDate: payload.endDate,
        status: 'pending',
        reason: payload.reason,
        appliedAt: new Date().toISOString(),
      });
    }
    return httpAPI
      .post<IGuardianLeaveRecord>(baseGuardianLeavesPath, payload)
      .then((res: any) => res?.data ?? res);
  };

  return { getLeaveStats, getLeaves, applyLeave };
};

export default useGuardianLeavesService;
